(() => {
  const initCountdown = (root) => {
    if (root.dataset.apPhWcReady === "true") return;
    root.dataset.apPhWcReady = "true";

    const update = () => {
      const target = new Date(root.dataset.apPhCountdownTarget).getTime();
      if (!Number.isFinite(target)) return;

      const diff = Math.max(0, target - Date.now());
      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      root.querySelector("[data-ap-days]").textContent = String(days).padStart(2, "0");
      root.querySelector("[data-ap-hours]").textContent = String(hours).padStart(2, "0");
      root.querySelector("[data-ap-minutes]").textContent = String(minutes).padStart(2, "0");
      root.querySelector("[data-ap-seconds]").textContent = String(seconds).padStart(2, "0");
    };

    update();
    window.setInterval(update, 1000);
  };

  const showToast = (message) => {
    let toast = document.querySelector("[data-ap-ph-wc-toast]");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "ap-ph-wc-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      toast.setAttribute("data-ap-ph-wc-toast", "");
      document.body.append(toast);
    }

    toast.textContent = message;
    toast.classList.add("is-visible");
    window.setTimeout(() => toast.classList.remove("is-visible"), 1400);
  };

  const copyCode = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      const temp = document.createElement("textarea");
      temp.value = code;
      document.body.append(temp);
      temp.select();
      document.execCommand("copy");
      temp.remove();
    }

    showToast(`${code} copied`);
  };

  const initCopyButtons = (root = document) => {
    root.querySelectorAll("[data-ap-ph-copy-code]").forEach((button) => {
      if (button.dataset.apPhWcReady === "true") return;
      button.dataset.apPhWcReady = "true";
      button.addEventListener("click", () => copyCode(button.dataset.apPhCopyCode));
    });
  };

  const init = (root = document) => {
    root.querySelectorAll("[data-ap-ph-countdown-target]").forEach(initCountdown);
    initCopyButtons(root);
  };

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (event) => init(event.target));
  init();
})();
